import React, { useState } from 'react';
import {
  Layout,
  Button,
  Typography,
  Card,
  Form,
  Input,
  notification,
} from 'antd';

import { signup } from 'src/services/auth.service';
import { Link } from 'react-router-dom';

const { Title } = Typography;
const { Header, Content } = Layout;

const SignUp = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const openNotificationWithIcon = ({ type, message, description }) => {
    notification[type]({
      message,
      description,
    });
  };

  const onFinish = async (values) => {
    const { username, password } = values;

    try {
      setLoading(true);
      // After successful signup, redirect to sign-in page
      const { msg } = await signup({ username, password });
      openNotificationWithIcon({
        type: 'success',
        message: msg || 'Registration Successful',
        description: 'Your registration is complete. Waiting for approval.',
      });
    } catch (error) {
      console.error('Error during sign-up:', error);
      openNotificationWithIcon({
        type: 'error',
        message: 'Sign Up Failed',
        description:
          error.response?.data?.msg || 'An error occurred during sign up.',
      });
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <>
      <div className='layout-default ant-layout layout-sign-up'>
        <Header>
          <div className='header-col header-brand'>
            <h5>Bitoreum Dashboard</h5>
          </div>
        </Header>

        <Content className='p-0'>
          <div className='sign-up-header'>
            <div className='content'>
              <Title>Sign Up</Title>
              <p className='text-lg'>
                Use these awesome forms to login or create new account in your
                project for free.
              </p>
            </div>
          </div>

          <Card
            className='card-signup header-solid h-full ant-card pt-0'
            title={<h5>Register With</h5>}
            bordered='false'
          >
            <Form
              form={form}
              name='basic'
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className='row-col'
            >
              <Form.Item
                name='username'
                rules={[
                  { required: true, message: 'Please input your username!' },
                ]}
              >
                <Input placeholder='Username' />
              </Form.Item>
              <Form.Item
                name='password'
                rules={[
                  { required: true, message: 'Please input your password!' },
                ]}
              >
                <Input.Password placeholder='Password' />
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ width: '100%' }}
                  type='primary'
                  htmlType='submit'
                  loading={loading}
                >
                  SIGN UP
                </Button>
              </Form.Item>
            </Form>
            <p className='font-semibold text-muted text-center'>
              Already have an account?{' '}
              <Link to='/sign-in' className='font-bold text-dark'>
                Sign In
              </Link>
            </p>
          </Card>
        </Content>
      </div>
    </>
  );
};

export default SignUp;
